export const SOCIAL_AUTH_ATTEMPT_KEY = "socialAuthAttempt";
